import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import Links from 'ui/components/generic/Links'
import { Relative } from 'ui/styles/utils'
import index from '../Header/index'
import theme from 'ui/styles/theme'


export default class DealerSelector extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    dealers: [],
    isMobile: false,
    dealerHeight: ''
  }


  componentDidMount = () => {
    this.detectMobile();
    //Initiate an empty array to store dealers and images
    const parsedDealers = [];
    this.parseDealers(parsedDealers);
    this.setState({ dealers: parsedDealers });
  }

  componentDidUpdate = (state) => {
    if (this.state.dealerHeight == '') {
      this.getDealerHeight();
    }
  }


  //Loop through dealer array and add it to parsedDealers and add attached image
  parseDealers = (parsedDealers) => {
    this.props.select_dealer.map((element, index) => {
      let a = element.dealer_selector;
      let image = {
        img: element.dealer_image.sourceUrl
      };
      let alt_link = {
        alt: element.alternative_url.alt_url,
        display_url: element.alternative_url.display_url
      };
      let b = JSON.parse(a);
      let connectedDealer = {
        ...b,
        ...image,
        ...alt_link
      }
      parsedDealers.push(connectedDealer);
    })
  }

  //Check if website is accessed from a phone
  detectMobile = () => {
    const width = window.innerWidth
    const isMobile = width <= theme.grid.breakpoints.lg

    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile })
    }
  }



  //Remove http or https from displayed location's url for aesthetic purposes
  removeHttp(x) {
    if (x.slice(0, 5) === "https") {
      x = x.slice(8);
      return x
    }
    else {
      x = x.slice(7)
      return x
    }
  }

  getDealerHeight() {
    let dealer = document.getElementById("dealer-column");
    let dealerContainer = dealer.getBoundingClientRect();
    this.setState({ dealerHeight: dealerContainer.height });
    console.log(this.state.dealerHeight);
  }


  render() {
    const { dealers, isMobile } = this.state
    const { dealer_title, salesman, connect, show_salesman, bgcolor, dealer_title_translation } = this.props

    const columnBorder = {
      border: '1px solid #EBEBEB',
      backgroundColor: "white",
      paddingLeft: '0px',
      paddingRight: '0px'
    };

    const alignBetween = {
      alignContent: "space-between",
      height: "100%"
    }

    const paddingSalesman = {
      border: '1px solid #EBEBEB',
      paddingRight: '20px',
      paddingLeft: '20px',
      height: this.state.dealerHeight,
      backgroundColor: "white"
    }

    const salesmanMargin = {
      marginLeft: '20px'
    }

    const addHeight = {
      wordWrap: "break-word"
    }

    const logoColumn = {
      paddingBottom: "10px"
    }

    const addPadding = {
      paddingLeft: "20px",
      paddingRight: "20px"
    }

    return (
      <Wrapper bgcolor={bgcolor}>
        <InnerWrapper fluid>
          <Row justifyContent={'between'}>
            {show_salesman &&
              <Col sm={12} md={6} xl={4} >
                <SalesmanTitle style={salesmanMargin}>{salesman.title}</SalesmanTitle>
                {salesman.translation &&
                  <SalesmanTitleTranslation>{salesman.translation}</SalesmanTitleTranslation>
                }
                <SalesmanColumn style={paddingSalesman} id={'salesman-column'} >
                  <Name>{salesman.salesman_name}</Name>
                  <Subtitle>{salesman.title}</Subtitle>
                  <Row>
                    <Col sm={12}>
                      <SalesmanText>
                        <p>Ext.:{salesman.phone_external}</p>
                        <p>Mobile:{salesman.phone_mobile}</p>
                        <p><a href={`mailto: ${salesman.email}`}>{salesman.email}</a></p>
                      </SalesmanText>
                    </Col>
                  </Row>
                  <Break />
                  <Row>
                    <DownCol xs={12} sm={12} className="logo-column">
                      <Linkedin>
                        <p>{salesman.connect} {salesman.salesman_name.includes(' ') ? salesman.salesman_name.substring(0, salesman.salesman_name.indexOf(' ')) : salesman.salesman_name}</p>
                        <a href={salesman.linkedin_link}>LinkedIn</a>
                      </Linkedin>
                    </DownCol>
                  </Row>
                </SalesmanColumn>
              </Col>
            }
            <DealerColumn sm={12} md={12} lg={12} xl={show_salesman ? 8 : 12}>
              <DealerTitle>{dealer_title}</DealerTitle>
              {dealer_title_translation &&
                <DealerTitleTranslation>{dealer_title_translation}</DealerTitleTranslation>
              }
              <Content style={columnBorder}>
                <Row style={addPadding} id={"dealer-column"}>
                  {dealers && dealers.map((location, index) => {
                    return (
                      <DealerCol sm={10} md={6} lg={dealers.length === 3 ? 4 : 6} xl={dealers.length === 3 ? 4 : 6} key={index} style={addHeight} >
                        <Row justifyContent={'between'} style={alignBetween}>
                          <Col xs={12} sm={12} >
                            <Text>
                              <p id={'location-title'}>{location.title}</p>
                              <p>{location.address}</p>
                              <p>{location.zip}</p>
                            </Text>
                            <Text>
                              <p><a href={`tel:${location.phone}`}>{location.phone}</a></p>
                              {location.mail &&
                                <p><a href={`mailto:${location.mail}`}>{location.mail}</a></p>
                              }
                              <p>{location.alt !== "" ? (<a href={location.alt} target="_blank">{location.display_url}</a>) : (<a href={location.url} target="_blank">{this.removeHttp(location.url)}</a>)}</p>
                            </Text>
                          </Col>
                          <DownCol xs={12} style={logoColumn}>
                            <Image image={location.img}></Image>
                          </DownCol>
                        </Row>
                      </DealerCol>
                    )
                  })}
                </Row>
              </Content>
            </DealerColumn>
          </Row>
        </InnerWrapper>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  position: relative;
  padding: 50px 0 75px;
  overflow: hidden;
  background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};


  ${media.lg`
    //padding: 100px 0 150px;
    margin: 0px 0;
  `}
`
const SalesmanColumn = styled.div`
display: flex;
flex-direction: column;
justify-content: space-evenly;
color: #004077;

`

const DealerTitleTranslation = styled.h2`
`
const SalesmanTitleTranslation = styled.h2`
`

const DealerCol = styled(Col)`
wordWrap: "break-word";
${media.xl`
background-color:white;
`}
`

const InnerWrapper = styled(Container)`
padding: 0 20px;
${media.lg`
padding: 0 20%;
`}
`


const Linkedin = styled.div`
padding-bottom: 20px;
${media.md`

`}
${media.lg`

`}

a{
    background-color:#0077B5;
    padding: 5px 20px 5px 20px;
    color: white;
    border-radius: 20px;
    text-decoration: none;
    transition: all .2s ease-in-out;
}

a:hover{
    color: white;
    background-color: #0291db;
}
`

const Break = styled.hr`
display: block;
height: 1px;
border: 0;
border-top: 1px solid #ccc;
margin: 1em 0;
padding: 0;

`

const SalesmanText = styled.div`
color: #004077;
p {
  margin-bottom: 2px;
}
`

const SalesmanTitle = styled.h2`

`

const DealerTitle = styled.h2`

`

const Text = styled.div`
  margin-bottom: 30px;

  font-weight: 300;
  font-size: 20px;
  line-height: 22px;
  color: ${props => props.theme.colors.text};

  #location-title{
    color: ${theme.colors.primary};
    font-size: 19px;
    font-weight: 500;
    padding-top: 30px;
    text-transform: uppercase;
  }
`
const Country = styled.p`
  color: ${theme.colors.primary};
  font-size: 12px;
  font-weight: 500;
  padding-top: 30px;
  text-transform: uppercase;
`

const Name = styled.p`
color: #004077;
text-transform: uppercase;
margin-bottom: 0;
font-size: 1.22em;
font-weight: 400;`

const Subtitle = styled.p`
font-weight: 500;
margin-bottom: 30px;
color: #004077;
`

const Image = styled.div`
width: 100%;
background: url(${props => props.image}) space;
height:100%;
background-size: contain;
background-repeat: no-repeat;
`
const DownCol = styled(Col)`
width: 100%;
height: 79px;
margin-top: 10px;

`
const Content = styled.div`
//justify-content: space-between;
  //height:100%;
  //display: flex;
  //flex-direction: column;
 
`

const DealerColumn = styled(Col)`
${media.xs`
  margin: 20px;
`}
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/DealerSelector/index.js